import React, { useEffect, useState } from 'react';
import "../CSS/Loader.css";
import IconImage from "../Images/BalajiLogoAcademy.jpeg";

const Loader = () => {

    const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer); 
  }, []);

  if (loading) {
    return (
      <div id="preloader-active">
        <div className="preloader d-flex align-items-center justify-content-center">
          <div className="preloader-inner position-relative">
            <div className="preloader-circle" />
            <div className="preloader-img pere-text">
              {/* <img src={IconImage}  alt="" /> */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  
  return null;
};

export default Loader;